import { render, staticRenderFns } from "./configApp.vue?vue&type=template&id=9f45477c&scoped=true"
import script from "./configApp.vue?vue&type=script&lang=js"
export * from "./configApp.vue?vue&type=script&lang=js"
import style0 from "./configApp.vue?vue&type=style&index=0&id=9f45477c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f45477c",
  null
  
)

export default component.exports